<template>
  <div class="information">
    <dl class="picture">
      <dt>
        <div @click='toggleShow'>
          <uploadImg message="Upload your profile picture here*" :imageUrl="basic_info.pic" v-show="true">
          </uploadImg>
        </div>
        <my-upload field="file" @crop-success="cropSuccess" @crop-upload-success="cropUploadSuccess" @crop-upload-fail="cropUploadFail" v-model="show" :width="300" :height="300" :url="action" langType='en'></my-upload>
        <p v-show='!f_state.inp15' class="state_notice">This is required.</p>
      </dt>
      <dd>
        <div class="picture_decoration">
          <p>Please upload a photo of yourself here. </p>
          <p>This photo will be used for your teacher profile page.</p>
          <p>Your photo should be professional, and have adequate lighting. Don't forget to smile!</p>
          <p>The photo may be in jpg or png formats, and the size should be 300 x 300.</p>
        </div>
        <div class="picture_sample">
          <div class="picture_img">
            <img src="~@img/user_img.jpg" alt="">
          </div>
          <p>Sample profile picture</p>
        </div>
      </dd>
    </dl>
    <div class="line_f clearfix">
      <div class="textInput">
        <h3 class="tile_name">First Name*</h3>
        <input type="text" v-model.trim='basic_info.first_name'>
        <p v-show='!f_state.inp1' class="state_notice">This is required.</p>
      </div>
      <div class="textInput">
        <h3 class="tile_name">Last Name*</h3>
        <input type="text" v-model.trim='basic_info.last_name'>
        <p v-show='!f_state.inp2' class="state_notice">This is required.</p>
      </div>
      <div class="textInput" style="visibility: hidden;">
        <!-- <h3 class="tile_name">Teacher Name*</h3>
        <input type="text" class='teacher_name' v-model.trim='basic_info.nick_name' disabled> -->
      </div>
    </div>
    <div class="personal_info clearfix">
      <div>
        <h3 class="tile_name">Birthday*</h3>
        <el-date-picker v-model="basic_info.birthday" type="date" placeholder="select" filterable>{{time}}</el-date-picker>
        <p v-show='!f_state.inp4' class="state_notice">This is required.</p>
      </div>
      <div>
        <h3 class="tile_name">Zoom account *</h3>
        <input class="zoom_id" v-model.trim="basic_info.zoom_id" type="text">
        <p v-show='!f_state.inp6' class="state_notice">This is required.</p>
      </div>
      <div>
        <h3 class="tile_name">Are you legally allowed to work in the US or Canada?</h3>
        <el-select v-model="basic_info.on_boarding_is_legal" filterable>
          <el-option v-for="(key,val) of datas.on_boarding_is_legal" :label="key" :value="val" :key="val">
          </el-option>
        </el-select>
        <p v-show='!f_state.inp5' class="state_notice">This is required.</p>
      </div>
    </div>
    <div class="personal_info clearfix">
      <div class="textInput">
        <h3 class="tile_name">Country Code*</h3>
        <input v-model.trim="basic_info.country_code" type="text">
        <p v-show='!f_state.inp7' class="state_notice">This is required.</p>
      </div>
      <div class="textInput">
        <h3 class="tile_name"> Phone Number*</h3>
        <input v-model.trim="basic_info.mobile" type="text">
        <p v-show='!f_state.inp8' class="state_notice">This is required.</p>
      </div>
      <div>
        <h3 class="tile_name">Your Current Time Zone*</h3>
        <el-select v-model="basic_info.time_zone" filterable>
          <el-option v-for="(key,val) of datas.time_zone" :label="val" :value="key" :key="key">
          </el-option>
        </el-select>
        <p v-show='!f_state.inp9' class="state_notice">This is required.</p>
      </div>
    </div>
    <div class="personal_info clearfix" v-if="english_proficiency != ''" >
      <div>
        <h3 class="tile_name">Please select your English proficiency level*</h3>
        <el-select v-model="english_proficiency" filterable disabled>
          <el-option v-for="(item, key) in datas.english_proficiency" :label="item" :value="key" :key="key">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="personal_info clearfix">
      <div>
        <h3 class="tile_name">Computer's Operating Systerm*</h3>
        <el-select v-model="basic_info.pc_type" filterable disabled>
          <el-option v-for="(item, key) in datas.operating_system" :label="item" :value="key" :key="key">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="upload_id">
      <h3 class="tile_name">Upload Valid ID* (Passport, Driver's License)</h3>
      <div class="upload_id_in">
        <file-upload :action='action' :before-upload='b_upload' @complete='upload_id'>
          <uploadImg message="Upload proof" :imageUrl="basic_info.valid_ids_url"></uploadImg>
        </file-upload>
      </div>
      <p v-show='!f_state.inp16' class="state_notice">This is required.</p>
    </div>
    <p class="select_tipes">Current location</p>
    <div class="last_input">
      <div class="personal_info clearfix">
        <div>
          <h3 class="tile_name">Country*</h3>
          <el-select v-model="basic_info.country" filterable>
            <el-option v-for="(key,val) of datas.country" :label="key" :value="val" :key="val">
            </el-option>
          </el-select>
          <p v-show='!f_state.inp10' class="state_notice">This is required.</p>
        </div>
        <div class="state">
          <h3 class="tile_name">State*</h3>
          <el-select v-if='state_change' v-model="basic_info.state" filterable>
            <el-option v-for="(key,val) of datas.state" :label="val" :value="key" :key="key">
            </el-option>
          </el-select>
          <input v-else type="text" v-model.trim="basic_info.state" class="state_input">
          <p v-show='!f_state.inp11' class="state_notice">This is required.</p>
        </div>
        <div class="zip_code">
          <h3 class="tile_name">City*</h3>
          <input v-model.trim='basic_info.city' type="text">
          <p v-show='!f_state.inp12' class="state_notice">This is required.</p>
        </div>
      </div>
      <div class="personal_info clearfix">
        <div class="street_input">
          <h3 class="tile_name">Street*</h3>
          <input type="text" v-model.trim="basic_info.street" class="street">
          <p v-show='!f_state.inp13' class="state_notice">This is required.</p>
        </div>
        <div class="zip_code">
          <h3 class="tile_name"> Zip Code*</h3>
          <input type="text" v-model.trim="basic_info.z_code">
          <p v-show='!f_state.inp14' class="state_notice">This is required.</p>
        </div>
      </div>
    </div>
    <div class="interest">
      <h3 class="interests_tit">The background and interests below will help our students get to know you better.</h3>
      <div class="item">
        <span class="item_left">Background</span>
        <ul class="background_list clearfix">
          <li v-for="(item, index) in background" :key="index" :class="{'active':item.isActive}" @click="inActive(index,'background','isActive')">{{item.name}}</li>
        </ul>
      </div>
      <div class="item">
        <span class="item_left">Interests</span>
        <ul class="background_list clearfix">
          <li v-for="(item, index) in interests" :key="index" :class="{'active':item.isActiveIn}" @click="inActive(index,'interests','isActiveIn')">{{item.name}}</li>
        </ul>
      </div>
    </div>
    <p class="save">
      <a href="javascript:;" @click="saveFn">Save</a>
    </p>
    <!-- Google pixel -->
    <div style="display:inline;">
      <img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/852175291/?label=6jqmCKjEsngQu9OslgM&amp;guid=ON&amp;script=0" />
    </div>
    <!-- Google pixel -->
    <div style="display:inline;">
      <img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/852175291/?label=h6YZCM7uyngQu9OslgM&amp;guid=ON&amp;script=0" />
    </div>
  </div>
</template>
<script>
import 'babel-polyfill'
import uploadImg from '@common/upload_img'
import myUpload from 'vue-image-crop-upload/upload-2.vue'
import basePath from '@api/basePath'

import fileUpload from '@common/file_upload'

export default {
  props: {},
  components: {
    uploadImg,
    'my-upload': myUpload,
    fileUpload
  },
  data() {
    return {
      state_change: false, //州省下拉输入切换
      datas: '',
      dataShow: '',
      message: 'This is required.',
      great: false,
      f_state: {
        inp1: false,
        inp2: false,
        inp3: true, //教师名字改到pso，此处不予以校验
        inp4: false,
        inp5: false,
        inp6: false,
        inp7: false,
        inp8: false,
        inp9: false,
        inp10: false,
        inp11: false,
        inp12: false,
        inp13: false,
        inp14: false,
        inp15: false,
        inp16: false
      },
      basic_info: {
        first_name: '',
        last_name: '',
        // nick_name: '',
        birthday: '',
        on_boarding_is_legal: '',
        country_code: '',
        mobile: '',
        zoom_id: '',
        time_zone: '',
        country: '',
        state: '',
        city: '',
        street: '',
        z_code: '',
        pc_type: '',
        pic: '',
        background: [],
        interests: [],
        valid_ids_url: '',
      },
      background: [],
      interests: [],
      i: 0,
      state_num: '',
      show: false,
      imgDataUrl: '',
      english_proficiency: ''
    }
  },
  created: function() {
    console.log(this.f_state.inp4)
    // 初始化页面数据
    let _this = this
    /*请求基本信息*/
    this.$http.get('/common/getConfig').then(
      function(response) {
        if (response.data && response.data.code == '75000') {
          _this.datas = response.data.res
          _this.background = this.objBgActiveFn
          _this.interests = this.objInterestsFn
          //请求返回已选项可编辑的保存状态
          this.$http.get('/Boarding/getTutor').then(
            function(response) {
              if (response.data && response.data.code == '75000') {
                console.log(response.data.res.info)
                this.dataShow = response.data.res.info
                this.english_proficiency = response.data.res.info.english_proficiency
                var showStr = this.dataShow.interests
                var showStrB = this.dataShow.background
                var arrShowB = []
                var arrShow = []
                if (showStr) {
                  arrShow = showStr.split(',')
                }
                if (showStrB) {
                  arrShowB = showStrB.split(',')
                }

                for (var item in this.basic_info) {
                  if (item == 'background') {
                    //把this.dataShow.background转换成数组赋值给this.basic_info.background
                    this.basic_info.background = arrShowB
                  } else if (item == 'interests') {
                    this.basic_info.interests = arrShow
                  } else if (this.dataShow[item] <= '0') {
                    //判断接口返回0，说明是空
                    this.basic_info[item] = ''
                  } else {
                    this.basic_info[item] = this.dataShow[item] //input的填写 名字之类的
                    console.log(this.dataShow[item])
                  }
                }

                // console.log(this.basic_info.pic)
                if (this.basic_info.pic != '') {
                  this.f_state.inp15 = true //未上传照片提示隐藏
                }
                /*if(this.basic_info.nick_name!=''){
              this.f_state.inp3 = true;//检查老师姓名
            }*/
                if (showStrB) {
                  for (var i = 0; i < arrShowB.length; i++) {
                    //背景默认选中选过的
                    for (var item in this.background) {
                      if (this.background[item].num == arrShowB[i]) {
                        this.background[item].isActive = true
                      }
                    }
                  }
                }
                if (showStr) {
                  for (var i = 0; i < arrShow.length; i++) {
                    //爱好默认选中选过的
                    for (var item in this.interests) {
                      if (this.interests[item].num == arrShow[i]) {
                        this.interests[item].isActiveIn = true
                      }
                    }
                  }
                }
              }
            },
            function() {
              console.log('service error')
            }
          )
        }
      },
      function() {
        console.log('service error')
      }
    )
    /*选择国家时，当没有州省的国家，则变为input-text，有则变为下拉*/
    this.$watch(
      function() {
        return this.basic_info.country
      },
      function(n, o) {
        /*cache方法，属于暂时处理的方法，因为联动出现了问题：选择country,state不更新，第二次改变country才会触发更新；
      但是当改变country时候，state会触发更新,日后有其他解决办法在处理*/
        let cache = this.datas['country']
        this.basic_info.state = '' //清空state
        this.i++
        this.$http
          .get(
            '/common/getStatesByCountryId' +
              '?country_id=' +
              _this.basic_info.country
          )
          .then(
            function(d) {
              if ((d.data.code = 75000)) {
                this.datas['country'] = {}
                this.datas['country'] = cache
                this.datas['state'] = d.data.res

                if (this.dataShow.state && this.i == 1) {
                  //判断如果州、省不为空的时候直接赋值
                  if (this.dataShow.state == '0') {
                    this.basic_info.state = ''
                  } else {
                    for (var item in d.data.res) {
                      if (this.dataShow.state == d.data.res[item]) {
                        this.basic_info.state = item
                        this.state_num = d.data.res[item]
                        console.log(this.basic_info.state, this.state_num)
                      }
                    }
                  }
                }
                /*州、省切换，当国家切换至没有州或者省的情况时，state下拉变为输入框*/
                this.state_change = d.data.res.length == 0 ? false : true
              }
            },
            function() {
              console.log('error')
            }
          )
      }
    )
  },
  methods: {
    upload_id(response, file, idx, attr) {
      if (response.code == 75000) {
        this.$message.success('Congratulations, upload success!')
        this.basic_info.valid_ids_url = response.res.url
      } else {
        this.$message.error('service error')
      }
    },
    b_upload(file, event) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'

      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error(
          'Upload avatar image can only be JPG and PNG format!'
        )
      }
      if (!isLt2M) {
        this.$message.error('Upload avatar picture size no more than 2 MB.')
      }
      return isJPG && isLt2M
    },
    inActive: function(index, typeIn, isTrue) {
      //点击背景和爱好
      this[typeIn][index][isTrue] = !this[typeIn][index][isTrue]
      if (this[typeIn][index][isTrue]) {
        this.basic_info[typeIn].push(this[typeIn][index].num)
      } else {
        var arrIndex = this.basic_info[typeIn].indexOf(this[typeIn][index].num)
        this.basic_info[typeIn].splice(arrIndex, 1)
      }
      console.log(this.basic_info[typeIn])
    },
    upload_img(res, file) {
      // if(response.code==75000){
      this.$message.success(' Upload successful！')
      this.f_state.inp15 = true
      this.basic_info.pic = res.res.url
    },
    beforeUploadImg(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      //以下是文件类型对应的type String
      //application/.jpg .png
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error('The profile picture format should be JPG or PNG.')
      }
      if (!isLt2M) {
        this.$message.error(
          'The profile picture size should be less than 2 MB.'
        )
      }
      this.f_state.inp15 = false
      return isJPG && isLt2M
    },
    detectFn: function() {
      //检查老师名称是否存在
      let _this = this
      let formdata = new URLSearchParams()
      if (_this.basic_info.nick_name == '') return
      formdata.append('nick_name', _this.basic_info.nick_name)
      this.axios.post('/Boarding/checkName', formdata).then(function(d) {
        if (d.data.code == 75070) {
          _this.message = d.data.message
          _this.great = true
          _this.f_state.inp3 = true
        } else if (d.data.code == 75071) {
          _this.message = d.data.message
          _this.great = false
          _this.f_state.inp3 = false
        }
      })
    },
    saveFn: function() {
      //保存
      console.log(this.f_state.inp4, this.basic_info.birthday)
      let pass = false
      let _this = this
      let formdata = new URLSearchParams()
      for (var opt in this.f_state) {
        console.log(this.f_state[opt], opt)
        if (this.f_state[opt]) {
          pass = true
        } else {
          pass = false
          break
        }
      }

      if (!pass) return
      if (typeof this.basic_info.state == 'string') {
        this.basic_info.state = this.state_num
      }
      // this.$router.push('personal_qa')
      for (let attr in this.basic_info) {
        formdata.append(attr, _this.basic_info[attr])
      }

      this.axios
        .post('/Boarding/addInformtion', formdata)
        .then(function(d) {
          if (d.data.code == 75000) {
            _this.$message.success('Success!')
            _this.$router.replace('/personal_profile/personal_qa')
          } else {
            _this.$message.error(d.data.message)
          }
        })
        .catch(() => {
          _this.$message.error('service error')
        })
    },
    toggleShow() {
      this.show = !this.show
    },
    /**
     * crop success
     *
     * [param] imgDataUrl
     * [param] field
     */
    cropSuccess(imgDataUrl, field) {
      this.imgDataUrl = imgDataUrl
    },
    /**
     * upload success
     *
     * [param] jsonData   服务器返回数据，已进行json转码
     * [param] field
     */
    cropUploadSuccess(jsonData, field) {
      if (jsonData.code == 75000) {
        this.f_state.inp15 = true
        this.basic_info.pic = jsonData.res.url
      } else {
        this.$message.error('upload error')
      }
    },
    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail(status, field) {}
  },
  watch: {
    basic_info: {
      handler: function(o, n) {
        this.f_state.inp1 = !this.basic_info.first_name ? false : true
        this.f_state.inp2 = !this.basic_info.last_name ? false : true
        this.f_state.inp4 = !this.basic_info.birthday ? false : true
        this.f_state.inp5 = !this.basic_info.on_boarding_is_legal ? false : true
        this.f_state.inp6 = !this.basic_info.zoom_id ? false : true
        this.f_state.inp7 = !this.basic_info.country_code ? false : true
        this.f_state.inp8 = !this.basic_info.mobile ? false : true
        this.f_state.inp9 = !this.basic_info.time_zone ? false : true
        this.f_state.inp10 = !this.basic_info.country ? false : true
        this.f_state.inp11 = !this.basic_info.state ? false : true
        this.f_state.inp12 = !this.basic_info.city ? false : true
        this.f_state.inp13 = !this.basic_info.street ? false : true
        this.f_state.inp14 = !this.basic_info.z_code ? false : true
        this.f_state.inp16 = !this.basic_info.valid_ids_url ? false : true
      },
      deep: true
    }
  },
  computed: {
    time: function() {
      let _this = this
      let time = new Date(_this.basic_info.birthday)
      let year = time.getFullYear()
      let mon =
        time.getMonth() + 1 < 10
          ? '0' + (time.getMonth() + 1)
          : time.getMonth() + 1
      let day = time.getDate() < 10 ? '0' + time.getDate() : time.getDate()

      time = year + '-' + mon + '-' + day
      if (time == 'NaN-NaN-NaN') {
        this.basic_info.birthday = ''
      } else {
        this.basic_info.birthday = time
      }
      return time
    },
    action() {
      return `${basePath}/Fileupload/uploadToHkOss`
    },
    objBgActiveFn: function() {
      var objBgActive = []
      for (var key in this.datas.background) {
        //渲染background
        objBgActive.item = {
          name: this.datas.background[key],
          isActive: false,
          num: key
        }
        objBgActive.push(objBgActive.item)
      }
      return objBgActive
    },
    objInterestsFn: function() {
      var objBgActive = []
      for (var key in this.datas.interests) {
        //渲染interests
        objBgActive.item = {
          name: this.datas.interests[key],
          isActiveIn: false,
          num: key
        }
        objBgActive.push(objBgActive.item)
      }
      return objBgActive
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less'>
.information {
  width: 1000px;
  .background_list {
    li {
      padding: 0 14px;
      height: 33px;
      line-height: 33px;
      margin-right: 10px;
      border: 1px solid #fcc800;
      color: #ffb400;
      margin-bottom: 25px;
      float: left;
      font-weight: bold;
      border-radius: 10px;
      cursor: pointer;
      font-size: 14px;
      &.active {
        background-color: #fcc800;
        color: #1e1e1e;
      }
    }
  }
  p.state_notice {
    padding: 5px 0 5px 15px;
    color: #fd4c6e;
    font-size: 14px;
    &.great {
      color: #01b101;
    }
  }
  .picture {
    height: 140px;
    margin-bottom: 30px;
    dt {
      width: 162px;
      height: 140px;
      float: left;
      background-color: #ccc;
    }
    dd {
      margin-left: 172px;
      background-color: #f7f7f7;
      height: 140px;
      padding-left: 28px;
      color: #525252;
      font-size: 14px;
      line-height: 17px;
    }
    .picture_decoration {
      padding-top: 28px;
      width: 552px;
      float: left;
      & > p:last-child {
        margin-top: 15px;
      }
    }
    .picture_sample {
      float: right;
      width: 244px;
      text-align: center;
      padding-top: 15px;
      & > p {
        line-height: 20px;
        font-size: 12px;
      }
      .picture_img {
        width: 90px;
        height: 90px;
        margin-left: 77px;
        margin-bottom: 5px;
        position: relative;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .line_f {
    margin-bottom: 20px;
    & > div:last-child {
      margin-right: 0;
      position: relative;
      width: 495px;
      input {
        width: 473px;
        padding-right: 10px;
        background-color: transparent;
      }
      span {
        width: 132px;
        position: absolute;
        height: 40px;
        line-height: 40px;
        background-color: #fcc800;
        color: #1e1e1e;
        font-size: 14px;
        text-align: center;
        border-radius: 0 8px 8px 0;
        top: 20px;
        right: 0;
        cursor: pointer;
      }
    }
    input:focus {
      border-color: #fcc800;
      box-shadow: 0 2px 2px 1px #fff2cc inset;
    }
  }
  .textInput {
    float: left;
    margin-right: 20px;
    position: relative;
    input {
      width: 210px;
      height: 38px;
      color: #1e1e1e;
      border: 1px solid #cccccc;
      border-radius: 10px;
      outline: none;
      padding: 0 10px;
      box-shadow: 0 2px 2px 1px #ebebeb inset;
    }
  }

  .attention {
    position: absolute;
    right: 0;
    top: 0;
    i {
      position: absolute;
      right: -31px;
      top: 30px;
      width: 16px;
      height: 16px;
      background: url('~@img/step.png') 0 -108px no-repeat;
    }
    p {
      width: 300px;
      padding: 10px;
      position: absolute;
      left: -220px;
      top: -173px;
      border: 1px solid #ccc;
      border-radius: 5px;
      background-color: #fff;
      font-size: 13px;
      color: #999;
      line-height: 17px;
      display: none;
      b {
        position: absolute;
        left: 231px;
        top: 173px;
        width: 16px;
        height: 8px;
        background: url('~@img/step.png') -20px -112px no-repeat;
      }
    }
  }
  .attention:hover {
    p {
      display: block;
    }
  }
  .skype {
    width: 463px;
    height: 38px;
    color: #999999;
    border: 1px solid #cccccc;
    border-radius: 10px;
    outline: none;
    padding: 0 10px;
    margin-right: 20px;
    box-shadow: 0 2px 2px 1px #ebebeb inset;
  }
  .zoom_id {
    width: 232px;
    height: 38px;
    color: #1e1e1e;
    border: 1px solid #cccccc;
    border-radius: 10px;
    outline: none;
    padding: 0 10px;
    box-shadow: 0 2px 2px 1px #ebebeb inset;
    box-sizing: border-box;
    margin-right: 20px;
  }
  .personal_info {
    margin-bottom: 20px;
    & > * {
      float: left;
    }
    .el-input {
      margin-right: 20px;
      width: 232px;
      input.el-input__inner {
        height: 38px;
        border-radius: 10px;
        border-color: #cccccc;
      }
      :-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #1e1e1e;
        opacity: 1;
      }
      ::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #1e1e1e;
        opacity: 1;
      }
      input:-ms-input-placeholder {
        color: #1e1e1e;
        opacity: 1;
      }
      input.el-select::-webkit-input-placeholder {
        color: #1e1e1e;
        opacity: 1;
      }
    }
    & > div:last-child {
      .el-input {
        width: 495px;
        margin-right: 0;
      }
    }
  }
  .last_input {
    .personal_info:nth-child(1) {
      :last-child {
        .el-select,
        .el-input {
          width: 233px;
        }

        input {
          width: 232px;
        }
      }
    }
  }
  .street_input {
    width: 482px;
    margin-right: 20px;
    input {
      width: 462px;
      height: 38px;
      color: #1e1e1e;
      border: 1px solid #cccccc;
      border-radius: 10px;
      outline: none;
      padding: 0 10px;
      box-shadow: 0 2px 2px 1px #ebebeb inset;
    }
  }
  .state {
    .state_input {
      width: 210px;
      height: 38px;
      color: #1e1e1e;
      border: 1px solid #cccccc;
      border-radius: 10px;
      outline: none;
      padding: 0 10px;
      box-shadow: 0 2px 2px 1px #ebebeb inset;
      margin-right: 20px;
    }
  }
  .zip_code {
    input {
      width: 232px;
      height: 38px;
      color: #1e1e1e;
      border: 1px solid #cccccc;
      border-radius: 10px;
      outline: none;
      padding: 0 10px;
      box-shadow: 0 2px 2px 1px #ebebeb inset;
    }
  }
  .select_tipes {
    font-size: 14px;
    color: #525252;
    font-weight: bold;
    margin-top: 48px;
    margin-bottom: 30px;
  }
  .interest {
    font-size: 14px;
    margin-bottom: 50px;
    .interests_tit {
      color: #525252;
      font-weight: bold;
      margin-top: 48px;
      margin-bottom: 30px;
    }
    .item {
      padding-left: 103px;
      position: relative;
    }
    .item_left {
      position: absolute;
      left: 0;
      top: 10px;
      color: #525252;
    }
    .background_list {
      min-height: 33px;
      li {
        padding: 0 14px;
        height: 33px;
        line-height: 33px;
        margin-right: 10px;
        border: 1px solid #fcc800;
        color: #ffb400;
        margin-bottom: 25px;
        float: left;
        font-weight: bold;
        border-radius: 10px;
        cursor: pointer;
        &.active {
          background-color: #fcc800;
          color: #1e1e1e;
        }
      }
    }
  }
  .save {
    text-align: center;
    margin-top: 80px;
    margin-bottom: 174px;
    a {
      color: #1e1e1e;
      width: 337px;
      height: 46px;
      line-height: 46px;
      background-color: #fcc800;
      font-size: 24px;
      display: inline-block;
      border-radius: 10px;
    }
  }
  .tile_name {
    font-size: 14px;
    color: #999;
    height: 20px;
    line-height: 1;
  }
  .upload_id {
    .upload_id_in {
      margin: 10px 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// personal_in.vue?68916e42